import { takeEvery } from "redux-saga/effects";

import { GALLAGHER_TWX_DATA_LOGGER_CONFIG } from "constants/actionTypes";
import toast from "lib/toast";

function handleConfigFailed() {
  toast.error(
    "Gallagher Data Logger is misconfigured - enable at least EID on the device, plus Weight and Units to also capture weights.",
  );
}

export default function* rootSaga() {
  yield takeEvery(GALLAGHER_TWX_DATA_LOGGER_CONFIG.FAILURE, handleConfigFailed);
}
